var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 .5a.5.5 0 0 0-1 0V5c0 1.327.332 2.458 1.028 3.264C1.733 9.081 2.758 9.5 4 9.5h6.119l-1.94 1.616a.5.5 0 1 0 .641.768l3-2.5a.5.5 0 0 0 0-.768l-3-2.5a.5.5 0 1 0-.64.768L10.119 8.5H4c-1.007 0-1.733-.331-2.215-.89C1.293 7.043 1 6.174 1 5z",
    clipRule: "evenodd"
  })));
});
const SvgArrowReplaysmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowReplaysmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDAuNUMxIDAuMjIzODU4IDAuNzc2MTQyIDAgMC41IDBDMC4yMjM4NTggMCAwIDAuMjIzODU4IDAgMC41VjVDMCA2LjMyNzE4IDAuMzMxNTg5IDcuNDU4MTMgMS4wMjc4NCA4LjI2NDMxQzEuNzMzMjkgOS4wODExNSAyLjc1NzM5IDkuNSA0IDkuNUgxMC4xMTlMOC4xNzk5MSAxMS4xMTU5QzcuOTY3NzcgMTEuMjkyNyA3LjkzOTExIDExLjYwOCA4LjExNTg5IDExLjgyMDFDOC4yOTI2NyAxMi4wMzIyIDguNjA3OTUgMTIuMDYwOSA4LjgyMDA5IDExLjg4NDFMMTEuODIwMSA5LjM4NDExQzExLjkzNDEgOS4yODkxMSAxMiA5LjE0ODM5IDEyIDlDMTIgOC44NTE2MSAxMS45MzQxIDguNzEwODkgMTEuODIwMSA4LjYxNTg5TDguODIwMDkgNi4xMTU4OUM4LjYwNzk1IDUuOTM5MTEgOC4yOTI2NyA1Ljk2Nzc3IDguMTE1ODkgNi4xNzk5MUM3LjkzOTExIDYuMzkyMDUgNy45Njc3NyA2LjcwNzMzIDguMTc5OTEgNi44ODQxMUwxMC4xMTkgOC41SDRDMi45OTI2MSA4LjUgMi4yNjY3MSA4LjE2ODg1IDEuNzg0NjYgNy42MTA2OUMxLjI5MzQxIDcuMDQxODcgMSA2LjE3MjgyIDEgNVYwLjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";